import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from "../componentes/header/header";
import Footer from "../componentes/footer/footer";
import { assets } from "../assets/assets";
import { abrirOrcamentoWhats, trazerRodapePaginasServicos, trazerTituloServicos } from '../utils/utils';
import './conserto_relogio.css'; // Reutilizando o CSS para manter o padrão

const CopiaChaves = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Trinco | Serviços de chaves";
  }, []);

  return (
    <div className="servico-detalhe-page">
      <Header />

      {/* Hero Banner */}
      <section className="servico-hero" style={{ backgroundImage: `url(${assets.copiaChaves})` }}>
        <div className="servico-hero-overlay">
          <h1>Serviços de Chaves</h1>
          <p>Quando uma chave falha, tudo para.</p>
        </div>
      </section>

      {/* Conteúdo Explicativo */}
      <main className="conteudo-servico-container">

        <article className="bloco-texto">
          <h2>{trazerTituloServicos('chaves')}</h2>
        </article>

        {/* Bloco 1: Chaves Yale e Tetra */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Yale e Tetra</h3>
            <h4>Cópia de chaves</h4>
            <p>Para reposição, reserva ou uso adicional.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.chavesYaleTetra} alt="Cópia de chaves yale e tetra" />
          </div>
        </section>

        {/* Bloco 2: Conserto e Troca de Segredo */}
        <section className="sessao-explicativa reverse">
          <div className="texto-lado">
            <h3>Fechaduras</h3>
            <h4>Troca de segredo</h4>
            <p>Reconfiguração da fechadura para novas chaves.</p>
            <h4>Troca de fechadura</h4>
            <p>Quando a fechadura apresenta desgaste ou falhas.</p>
            <h4>Instalação de fechadura</h4>
            <p>Aplicação de novos modelos na porta.</p>

          </div>
          <div className="imagem-lado">
            <img src={assets.consertoFechadura} alt="Manutenção de fechaduras" />
          </div>
        </section>

        {/* Bloco 3: Chaves Automotivas e Instalação */}
        <section className="sessao-explicativa">
          <div className="texto-lado">
            <h3>Chaves de carro</h3>
            <h4>Cópia de chave automotiva</h4>
            <p>Confecção e programação de chaves veiculares.</p>

            <h4>Conserto de chave automotiva</h4>
            <p>Reparo de chaves danificadas.</p>

            <h4>Troca de carcaça</h4>
            <p>Substituição da parte externa da chave.</p>

            <h4>Troca de botões</h4>
            <p>Reposição dos botões de comando.</p>
          </div>
          <div className="imagem-lado">
            <img src={assets.chaveCarro} alt="Serviços automotivos" />
          </div>
        </section>

        <div className="fechamento-texto">
          <h4>{trazerRodapePaginasServicos('serviços de chaves')}</h4>
        </div>

        {/* CTA FINAL */}
        <div className="cta-container-detalhe">
          <button className="btn-orcamento-whats" onClick={() => abrirOrcamentoWhats('serviços de chaves')}>
            Solicitar orçamento
          </button>
          <button className="btn-voltar-simples" onClick={() => navigate('/')}>
            Voltar para o início
          </button>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default CopiaChaves;